import TranslationError from '../Translations/TranslationError';
import Translations from '../Translations';
import React, {
    useState,
} from 'react';
import {
    Modal,
    Button,
} from 'semantic-ui-react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {
    toast,
} from 'react-toastify';

import {
    handleUpdateLeaveBarterOption,
} from '../../actions';
import LeaveBarterOption from '../leave_barter_item/option';

const ModalSelectLeaveBarterOption = (props) => {

    const {
        id,
        options,
        choice,
        handleUpdateLeaveBarterOption,
        currencyMinorUnit,
        currency,
    } = props;

    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(choice.key);
    const [loading, setLoading] = useState(false);

    const handleUpdateSelectedOption = (selectedOptionKey) => {
        setSelectedOption(selectedOptionKey);
    };

    const renderOptions = () => {
        return _.map(options, (option) => {
            return (
                <LeaveBarterOption
                    key={option.key}
                    selectedOption={selectedOption}
                    handleUpdateSelectedOption={handleUpdateSelectedOption}
                    option={option}
                    currencyMinorUnit={currencyMinorUnit}
                    currency={currency}
                />
            );
        });
    };

    const handleSubmitOption = () => {
        setLoading(true);

        const selectedOptionData = _.find(options, (option) => option.key === selectedOption);

        handleUpdateLeaveBarterOption({
            id,
            type: selectedOptionData.type,
            numberOfDays: selectedOptionData.numOfDays,
        }, 
        // error
        (error) => {
            setLoading(false);
            // console.warn(error);
            toast.error(<TranslationError error={error} backup="Your option could not be updated. Please try again." />);
        }, 
        // success
        () => {
            setLoading(false);
            setOpen(false);
            toast.success(<Translations text="selection.option_updated_successfully" backup={"Option was updated successfully"} />);
        });
    };
    
    return (
        <Modal
            open={open}
            dimmer="inverted"
            trigger={(
                <Button
                    fluid
                    content={`${choice.type.toUpperCase()} ${choice.numOfDays} day(s)`}
                    disabled={props.disabled}
                    // size="tiny" 
                    labelPosition="right"
                    icon="edit"
                    onClick={() => setOpen(true)}
                    style={{marginTop: 10}}
                />
            )}
        >
            <Modal.Header><Translations text="selection.change_leave_option" backup={"Change Leave Option"} /></Modal.Header>
            <Modal.Content>
                {renderOptions()}
            </Modal.Content>
            <Modal.Actions>
                <Button 
                    secondary
                    disabled={loading}
                    onClick={() => {
                        setSelectedOption(choice.key);
                        setOpen(false);
                    }}
                ><Translations text="common.cancel" backup={"Cancel"} /></Button>
                <Button
                    loading={loading}
                    content={<Translations text="common.save" backup={"Save"} />}
                    primary
                    labelPosition="right"
                    icon="checkmark"
                    onClick={handleSubmitOption}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default connect(null, {
    handleUpdateLeaveBarterOption,
})(ModalSelectLeaveBarterOption);
